import { luscinia } from "./luscinia";
import { WizardState } from "./wizard";

luscinia.applyWizardState = function (wizardForm: JQuery<HTMLFormElement>, state: WizardState) {
    writeStateToLocal(state);
    updateWizardUI(wizardForm, state);
    luscinia.executeActionList(state.parameterSyncActions, wizardForm, false);
};
function updateWizardUI(wizardForm: JQuery<HTMLFormElement>, state: WizardState) {
    if (state.finishBtnEnabled) {
        wizardForm.find(".wizard-complete").removeAttr("disabled");
    }
    else {
        wizardForm.find(".wizard-complete").attr("disabled", "");
    }

    //Enable all previous and next btn's
    wizardForm.find(".wizard-previous").removeAttr("disabled");
    wizardForm.find(".wizard-next").removeAttr("disabled");

    let index = 0;
    let wizardBlock = $(".block-wizard");
    for (let stepState of state.wizardStepStates) {
        let stepTab = wizardBlock.find(`[data-stepname='${stepState.name}']`);

        //Disable or enable steptab
        if (stepState.enabled) {
            stepTab.attr("data-disabled", "false");
        } else {
            stepTab.attr("data-disabled", "true");
        }

        //Hide or show steptab
        if (stepState.visible) {
            stepTab.removeAttr("hidden");
        }
        else {
            stepTab.attr("hidden", "");
        }

        let wizardId = "#" + $('.wizard-ux').attr("id");
        let traversable = $(wizardId).hasClass("traversable");
        if (traversable) {
            if (stepState.enabled) {
                stepTab.css("cursor", "pointer");
                stepTab.css("pointer-events", "");
            }
            else {
                stepTab.css("cursor", "default");
                stepTab.css("pointer-events", "none");
            }
        }

        //Enable or disable neighbouring buttons
        if (!stepState.enabled && stepState.required) {
            for (let i = index - 1; i >= 0; i--) {
                var previousStep = state.wizardStepStates[i];
                if (previousStep.visible) {
                    let stepTab = wizardBlock.find(`[data-stepname='${previousStep.name}']`);
                    let tabIdentifier = stepTab.data('target');
                    let nextBtn = $(tabIdentifier).find('.wizard-next');
                    nextBtn.attr("disabled", "");
                    break;
                }
            }
            for (let i = index + 1; i < state.wizardStepStates.length; i++) {
                var nextStep = state.wizardStepStates[i];
                if (nextStep.visible) {
                    let stepTab = wizardBlock.find(`[data-stepname='${nextStep.name}']`);
                    let tabIdentifier = stepTab.data('target');
                    let previousBtn = $(tabIdentifier).find('.wizard-previous');
                    previousBtn.attr("disabled", "");
                    break;
                }
            }
        }
        index++;
    }
}

export function injectWizardStateToForm(serializedForm: FormData) {
    const wizardState = getWizardStateFromLocal();
    serializedForm.set("wizardState", JSON.stringify(wizardState));
}
export function getWizardStateFromLocal(): WizardState {
    return JSON.parse(localStorage.getItem("wizardState"));
}
function writeStateToLocal(state: WizardState) {
    localStorage.setItem("wizardState", JSON.stringify(state));
}